import { Injectable } from "@angular/core";
import {
    BaseNotificationEventsService,
    DssCommentNotificationType,
    DssNotification,
    DssNotificationsService,
} from "@dtm-frontend/dss-shared-lib";
import { Notification, NotificationDisplay, SharedNotificationDisplayProps } from "@dtm-frontend/shared/notifications";
import { IconName } from "@dtm-frontend/shared/ui";
import { FunctionUtils } from "@dtm-frontend/shared/utils";
import { TranslocoService } from "@jsverse/transloco";

@Injectable({
    providedIn: "root",
})
export class AnspCommentNotificationEventsService implements BaseNotificationEventsService {
    constructor(private readonly translocoService: TranslocoService, private readonly dssNotificationsService: DssNotificationsService) {}

    public getEventsList(notificationsToFormat: DssNotification[]): NotificationDisplay[] {
        return notificationsToFormat
            .filter((notification) =>
                this.dssNotificationsService.getDssCommentNotificationTypes().some((type) => notification.payload.type === type)
            )
            .map((notification) => {
                const sharedProps = this.getSharedProps(notification, "chat");

                switch (notification.payload.type) {
                    case DssCommentNotificationType.AddedCommentForRestrictionApplicationEvent:
                        return this.getAddedCommentForRestrictionApplicationEvent(sharedProps, notification);

                    case DssCommentNotificationType.AddedCommentForRestrictionModificationApplicationEvent:
                        return this.getAddedCommentForRestrictionModificationApplicationEvent(sharedProps, notification);

                    default:
                        return null;
                }
            })
            .filter(FunctionUtils.isTruthy);
    }

    private getAddedCommentForRestrictionApplicationEvent(
        sharedProps: SharedNotificationDisplayProps,
        notification: DssNotification
    ): NotificationDisplay {
        return {
            ...sharedProps,
            title: this.translocoService.translate("dssAdmin.notifications.commentLabel"),
            text: this.translocoService.translate("dssAdmin.notifications.addedCommentText"),
            redirectUrl: `flight-zone/${notification.payload.id}`,
        };
    }

    private getAddedCommentForRestrictionModificationApplicationEvent(
        sharedProps: SharedNotificationDisplayProps,
        notification: DssNotification
    ): NotificationDisplay {
        return {
            ...sharedProps,
            title: this.translocoService.translate("dssAdmin.notifications.commentLabel"),
            text: this.translocoService.translate("dssAdmin.notifications.addedCommentText"),
            redirectUrl: `modifications/${notification.payload.id}`,
        };
    }

    private getSharedProps(notification: Notification, icon: IconName): SharedNotificationDisplayProps {
        return { icon, date: notification.createdAt, id: notification.id, isRead: notification.read };
    }
}
